import request from "../../../helpers/request";

export const postAlertasInserirInformacao = async ({ id, info }) => {
  if (!id) return null;
  const url = `${process.env.REACT_APP_API}/Alerta/Info/${id}`;
  const result = await request({
    url,
    method: "post",
    data: { id, info },
  });

  console.log("postAlertasInserirInformacao", result);
  return result.data;
};
